import { isNullOrEmptySpace, NO_VALUE_DISPLAY } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvTextCellTransformer = (): {
  getTextValue: CsvCellTransformerFn;
} => {
  const getTextValue = ({
    value,
    valueTranslated,
  }: ICsvColumnTransformer): string => {
    const valueComputed = String(valueTranslated ?? value ?? "");

    return !isNullOrEmptySpace(valueComputed)
      ? valueComputed
      : NO_VALUE_DISPLAY;
  };

  return { getTextValue };
};
